enum StoreBuTypeEnum {
	ecommerce = 'E-commerce',
	store = 'Store',
	office = 'Office',
	smallStore = 'Small Store',
	shop = 'Shop'
}

export default StoreBuTypeEnum;
